import component from './UploadImage'
export default component
